import React from 'react'
import SEO from '../components/SEO'
import Layout from '../components/Layout'
import Signupnow3 from '../components/CTAsections/Signupnow3'

const Demo = () => {
  return (
    <Layout>
      <SEO
        title="Introduction to HomeLight Listing Management (HLM)  | The escrow period is 40% faster when pre-listing disclosures are provided before buyers make offers."
        meta={[
          {
            name: `title`,
            content:
              'Introduction by HomeLight Listing Management (HLM)  | The escrow period is 40% faster when pre-listing disclosures are provided before buyers make offers.',
          },
          {
            name: `description`,
            content:
              "This short how-to video will explain the basic in's and out's of the tool that over 70% of the Top 100 Teams in Silicon Valley, CA use and recommend. HomeLight Listing Management (HLM) ",
          },
          {
            property: `og:image`,
            content: 'https://disclosures-cdn.s3-us-west-2.amazonaws.com/assets/Marketing/hlm-mktg-site/HLM+Social+Final+1.png',
          },
          {property: 'og:image:width', content: '600'},
          {property: 'og:image:height', content: '315'},
          {property: `og:title`, content: 'HomeLight Listing Management (HLM)'},
          {property: 'og:url', content: 'https://disclosures.io'},
          {
            property: `og:description`,
            content:
              "This short how-to video will explain the basic in's and out's of the tool that over 70% of the Top 100 Teams in Silicon Valley, CA use and recommend. HomeLight Listing Management (HLM)",
          },
          {property: 'og:site_name', content: 'HomeLight Listing Management (HLM)'},
          {property: `og:type`, content: `website`},
          {name: `twitter:card`, content: `summary_large_image`},
          {name: `twitter:site`, content: `@Disclosuresio`},
          {name: `twitter:creator`, content: '@Disclosuresio'},
          {name: `twitter:title`, content: "HomeLight Listing Management (HLM) | On-market to offer accepted, faster! - Sign Up Now! (It's free!)"},
          {
            name: `twitter:description`,
            content:
              "This short how-to video will explain the basic in's and out's of the tool that over 70% of the Top 100 Teams in Silicon Valley, CA use and recommend. HomeLight Listing Management (HLM)",
          },
          {
            name: 'keywords',
            content:
              'HomeLight Listing Management (HLM), Disclosures.io, Disclosures.io introduction, Disclosures.io features, Disclosures.io faq, Disclosures.io help, Disclosures.io BBB, real estate broker tools, real estate listing management, disclosure package, property package, real estate disclosure, realtor crm, nhd report, property disclosure, real estate transaction management, realtor tools, tc tools, real estate crm, real estate software, buyers agent, home disclosure, listing agent,',
          },
        ]}
      />

      <div className=" text-dark text-center bg-white th-home--mobilefonth3 th-home--mobiletop-demo pb-2" style={{marginTop: '', paddingTop: '8rem'}}>
        <div className="h1 th-home--mobilefonth1 th-home--padmob " style={{paddingBottom: '1rem'}}>
          How it works
        </div>

        <div className="h5 th-home--mobilefonth4 th-home--padmob " style={{marginBottom: '1rem'}}>
          Share supplemental docs, monitor activity, and manage offers - in one place.
        </div>

        <div className="container grid-md bg-white px-2 th-home--padmob zvideotop" style={{marginTop: '4rem'}}>
          <div className="container grid-md " style={{}}>
            <div className="video-responsive zvideotop" style={{color: '#f5f6f9'}}>
              <iframe
                width="640"
                height="360"
                src="https://player.vimeo.com/video/347112369?autoplay=0&title=0&byline=0&portrait=0"
                title="Introduction Demo"
                style={{border: '0px #f5f6f9 solid', backgroundColor: '#ffffff', borderRadius: '10px'}}
              />
            </div>
          </div>
        </div>
        <div className="p py-4 pb-16 th-home--mobilefonth4 " style={{marginBottom: '-5rem'}}>
          Please enjoy our short introduction video.
        </div>

        {/* <div className=" zvideobottom ">
          <img
            className=" size-full pl-12 "
            src="https://disclosures-cdn.s3-us-west-2.amazonaws.com/assets/Marketing/ios+images/screens+extended.png"
            width="100%"
            height="auto"
            style={{float: 'right'}}
          />
        </div> */}

      </div>

      {/* <div class="bg-gray">
        <div class="container grid-sm p-6">
          <div className="h3 pb-2 text-center"> Sign up now!</div>
          <SignupForm size="md" />
        </div>
      </div> */}

      {/* <div class="bg-white">
        <div className="container " style={{padding: '4rem 0 0rem 0'}}>
          <div class="container grid-lg">
            <div class="columns  text-center" style={{padding: '20px', color: '#00414b'}}>
              <div class="column col-md-12 bg-transparent pb-6">
                <p style={{fontSize: '1rem', textAlign: 'center', marginBottom: '.5rem'}}>Award Winning</p>
                <p style={{fontSize: '.6rem', textAlign: 'center', marginBottom: '1rem'}}>2019 Innovation Award</p>
                <div className="video-responsive  " style={{color: '#00414b', boxShadow: ' 0px 0px 8px rgba(0, 0, 0, 0.1)'}}>
                  <iframe
                    src="https://player.vimeo.com/video/363416049?autoplay=0&title=0&byline=0&portrait=0"
                    title="Introduction Demo"
                    style={{borderRadius: '0px', boxShadow: ' 0px 0px 8px rgba(0, 0, 0, 0.1)'}}
                  />
                </div>
              </div>
              <div class="column col-md-12 bg-transparent pb-6">
                <p style={{fontSize: '1rem', textAlign: 'center', marginBottom: '.5rem'}}>Broker Owner Approved</p>
                <p style={{fontSize: '.6rem', textAlign: 'center', marginBottom: '1rem'}}>Gretchen Pearson, Owner BHHS Drysdale </p>
                <div className="video-responsive  " style={{color: '#00414b', boxShadow: ' 0px 0px 8px rgba(0, 0, 0, 0.1)'}}>
                  <iframe
                    width="640"
                    height="360"
                    src="https://player.vimeo.com/video/363439880?autoplay=0&title=0&byline=0&portrait=0"
                    title="Introduction Demo"
                    style={{borderRadius: '0px', border: '2px solid #000000', boxShadow: 'inset 0px 0px 0px 8px #000000 ', boxSizing: ' border-box'}}
                  />
                </div>
              </div>

              <div class="column col-md-12 bg-transparent pb-6">
                <p style={{fontSize: '1rem', textAlign: 'center', marginBottom: '.5rem'}}>Top Agent Recommended</p>
                <p style={{fontSize: '.6rem', textAlign: 'center', marginBottom: '1rem'}}>Butch Haze, Top Producer - San Francisco</p>
                <div className="video-responsive  " style={{color: '#00414b', boxShadow: ' 0px 0px 8px rgba(0, 0, 0, 0.1)'}}>
                  <iframe
                    src="https://player.vimeo.com/video/344350257?autoplay=0&title=0&byline=0&portrait=0"
                    title="Introduction Demo"
                    style={{borderRadius: '0px'}}
                  />
                </div>
              </div>
              <div class="column col-md-12 bg-transparent pb-6">
                <p style={{fontSize: '1rem', textAlign: 'center', marginBottom: '.5rem'}}>Team Ready</p>
                <p style={{fontSize: '.6rem', textAlign: 'center', marginBottom: '1rem'}}>Wendy Moore, Owner The W.Moore Team</p>
                <div className="video-responsive  " style={{color: '#00414b', boxShadow: ' 0px 0px 8px rgba(0, 0, 0, 0.1)'}}>
                  <iframe
                    src="https://player.vimeo.com/video/361969265?autoplay=0&title=0&byline=0&portrait=0"
                    title="Introduction Demo"
                    style={{borderRadius: '0px'}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <Howitworks /> */}

      <div id="andchor-demohow"></div>

      {/* <Val2 />
      <Propinfo />

      <Val3 />
      <Activity />
      <Val4 />
      <Receiveoffers />

      <Val1 />
      <Collab />
      <Val5 /> */}

      <Signupnow3 />
    </Layout>
  )
}

export default Demo
